import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavMenuVZY from './NavMenuVZY';

export const VzyLayout = (props) => {

    const location = useLocation();

    const [currentroute, setcurrentroute] = useState(location.pathname);

    useEffect(() => {
        setcurrentroute(location.pathname);
    }, [location]);

    return (
        <div className="layout-main vzy-container">
            <NavMenuVZY />
            {props.children}
        </div>
    );
}
